export const CREATE_UPLOAD = "CREATE_UPLOAD";
export const DELETE_UPLOADED_FILE = "DELETE_UPLOADED_FILE";